import { ChangeDetectionStrategy, Component, InputSignal, Signal, computed, inject, input } from '@angular/core';

import { IBlock, imagesOfContent } from '@rt-tools/cms-contract';
import { BlockDirective, ElemDirective } from '@rt-tools/core';

import { BLOG_BLOCK_PAGE, IBlogBlockPage } from '../blog-block-page.tokens';

const BEM_BLOCK: string = 'sc-blog-image-block';

@Component({
    selector: 'sc-blog-image-block',
    templateUrl: './blog-image-block.component.html',
    styleUrl: './blog-image-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class BlogImageBlockComponent {
    readonly #page: Signal<IBlogBlockPage> = inject(BLOG_BLOCK_PAGE);

    protected readonly images: Signal<IBlock.Content.Image[]> = computed(() => imagesOfContent(this.content()));
    /** Описание картинки для чтения с экрана — заголовок статьи. */
    protected readonly alt: Signal<string> = computed((): string => this.#page().title);

    /** Содержимое блока картинки: картинки медиатеки по порядку. */
    public readonly content: InputSignal<string> = input.required<string>();
}
